export const mutations = {
  SET_WORDS: (state, action) => {
    state.words = action.words;
  },
  SET_LOADING: (state, action) => {
    state.isLoading = action.isLoading;
  },
  SET_PAGINATION: (state, action) => {
    state.pagination = action.pagination;
  },
};
